<template>
  <div class="app-content-wrapper apps-wrapper --filemanager shadow-lg">
    <div
      :class="{open: isBlock}"
      class="app-overlay"
      @click="overlayApp"
    />
    <div
      :class="{open: isOpen}"
      class="app-sidebar"
    >
      <div class="app-sidebar-header white py-5">
        <v-btn
          :disabled="loading"
          class="rounded-lg py-5"
          :loading="source.state2 === 'processing'"
          tile
          block
          color="primary"
          @click="syncNow()"
        >
          <v-icon left>
            mdi-folder-sync-outline
          </v-icon> Sync now
        </v-btn>
      </div>
      <vue-perfect-scrollbar
        :settings="{suppressScrollX: true, wheelPropagation: false}"
        class="h-100 rtl-ps-none ps scroll"
        style="height: 100%"
      >
        <div class="app-sidebar-body mt-6">
          <base-card>
            <v-card-title>
              <div class="card-title mb-0">
                My drive
              </div>
            </v-card-title>
            <v-card-text>
              <p
                class="p-l-20 text-body-2"
                style="word-break: break-all;"
              >
                <span class="text--disabled font-weight-medium">Name:</span>
                {{ source.name }}<br>
                <span class="text--disabled font-weight-medium">Login:</span>
                {{ source.source.login }}<br>
                <span class="text--disabled font-weight-medium">Password: </span>
                <span v-if="!showPassword">{{ hiddenPassword }}</span>
                <span v-if="showPassword">{{ source.source.password }}</span>
                <i
                  v-if="!showPassword"
                  class="mdi mdi-eye p-l-5 text--pointer text--disabled"
                  @click="showPassword = !showPassword"
                />
                <i
                  v-if="showPassword"
                  class="mdi mdi-eye-off p-l-5 text--pointer text--disabled"
                  @click="showPassword = !showPassword"
                /><br>
                <span class="text--disabled font-weight-medium">Folder:</span>
                {{ (source.source.host + source.source.path) || '' }}<br>
                <span class="text--disabled font-weight-medium">Watchfolder:</span>
                {{ source.type === 'ftp-watchfolder' ? 'On' : 'Off' }}
              </p>
            </v-card-text>
          </base-card>
          <v-list flat>
            <v-subheader
              class="text--disabled font-weight-medium text-uppercase"
            >
              Status
            </v-subheader>

            <v-list-item-group
              v-model="selectedItem"
              color="primary"
            >
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                class="px-10"
                @change="filterByStatus(item)"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon v-text="item.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-medium"
                    v-text="item.text + ' (' + item.count + ')'"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list flat>
            <v-subheader
              class="text--disabled font-weight-medium text-uppercase"
            >
              File types
            </v-subheader>
            <v-list-item-group>
              <v-list-item
                v-for="(item, i) in fileTypes"
                :key="i"
                class="px-10"
              >
                <v-list-item-content>
                  <v-checkbox
                    v-model="selectedTypes"
                    class="ma-0 pa-0"
                    hide-details
                    :color="item.color"
                    :value="item.text"
                    :label="item.text + ' (' + item.count + ')'"
                    @change="filterByFileTypes()"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list
            v-if="source.our"
            disabled
            dense
            two-line
          >
            <v-subheader
              class="text--disabled font-weight-medium text-uppercase pl-2"
            >
              storage
            </v-subheader>
            <v-list-item-group
              color="primary"
              class=""
            >
              <v-list-item class="ma-0">
                <v-list-item-icon class="mr-1 pt-4">
                  <v-icon>mdi-floppy</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-medium"
                  >
                    {{ totalSizeFormatted }} used of 200GB
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-progress-linear
                      :value="totalSize*100/limit"
                      class="w-24"
                    />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </vue-perfect-scrollbar>
    </div>
    <div class="app-content relative">
      <div class="app-header white">
        <div
          class="d-flex justify-space-between flex-wrap align-baseline"
        >
          <div>
            <div
              class="nested-sidebar-toggle d-md-none d-sm-block"
              @click="appToggle"
            >
              <v-icon color="dark">
                mdi-menu-open
              </v-icon>
            </div>
            <v-text-field
              v-model="search"
              hide-details="auto"
              class="sm:hidden md:flex ma-0 pa-0"
              label="Search"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @input="searchItems()"
            />
          </div>
          <div>
            <p
              v-if="!loading"
              class="text--disabled font-weight-medium ma-0"
            >
              Last synced:
              <span v-if="source.state2 !== 'processing'">
                {{ moment.utc(source.lastImportTime2).from(moment().utc()) }}
              </span>
              <span v-else>syncing now</span>
            </p>
          </div>
          <div />
        </div>
      </div>
      <vue-perfect-scrollbar
        id="scroll"
        ref="scroll"
        :settings="{suppressScrollX: true, wheelPropagation: false}"
        class="h-100 rtl-ps-none ps scroll"
        style="height: 100%"
      >
        <div class="app-body mt-10 px-8">
          <v-row>
            <v-col
              cols="12"
              class=""
            >
              <div class="card-title">
                All Files
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="!loading && folders.length === 0"
              cols="12"
            >
              <div class="text-center">
                FTP directory listing is empty
              </div>
            </v-col>
          </v-row>
          <!--v-row>
            <v-col
              cols="12"
              class=""
            >
              <p
                class="font-weight-medium ma-0 text--disabled text-12"
              >
                FOLDERS
              </p>
            </v-col>
          </v-row-->
          <v-container class="grid filemanager-content">
            <v-row>
              <v-col
                v-for="folder in folders"
                :key="folder.name"
                md="6"
                lg="4"
                class=""
              >
                <base-card>
                  <v-card-text class="bg-white">
                    <div class="d-flex align-center">
                      <v-icon class="mr-2">
                        mdi-folder-outline
                      </v-icon>
                      <div>
                        <p
                          class="font-weight-medium ma-0 text--pointer"
                          style="word-break: break-all;"
                          @click="jumpToFolder(folder)"
                        >
                          {{ folder.name }}
                        </p>
                        <p
                          class="text--disabled ma-0 text-body-2"
                        >
                          {{ folder.items.length }} files, {{ folder.size }}
                        </p>
                      </div>
                    </div>
                  </v-card-text>
                </base-card>
              </v-col>
            </v-row>
          </v-container>
          <template v-for="folder in folders">
            <v-row
              :id="`folder`+folder.name"
              :ref="`folder`+folder.name"
              :key="`folder`+folder.name"
            >
              <v-col
                cols="12"
                class=""
              >
                <p
                  class="font-weight-medium ma-0 text--disabled text-12 text-uppercase"
                >
                  Folder: {{ folder.name }}
                </p>
              </v-col>
            </v-row>
            <v-container
              :key="`items`+folder.name"
              class=""
            >
              <v-row>
                <v-col
                  v-for="item in folder.items"
                  :key="item.filepath"
                  md="6"
                  lg="4"
                  class=""
                >
                  <base-card>
                    <div class="py-6 text-center">
                      <v-icon
                        class="mr-2"
                        x-small
                        color="success"
                      >
                        mdi-circle
                      </v-icon>
                      {{ item.status }}
                    </div>
                    <v-card-text class="bg-white">
                      <p
                        class="card-text font-weight-bold ma-0"
                        v-html="highlightMatches(item.filepath)"
                      />
                      <p
                        class="text--disabled font-weight-medium ma-0"
                      >
                        {{ item.formattedSize }}
                      </p>
                      <p class="ma-0 text-body-2">
                        Uploaded: {{ moment(item.updated).utc().format('MMM D, YYYY HH:mm') }}
                      </p>
                    </v-card-text>
                  </base-card>
                </v-col>
                <v-col v-if="!folder.items.length">
                  No files
                </v-col>
              </v-row>
            </v-container>
          </template>
        </div>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>
<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import { processMediaSource } from '@/store/converters'
  import { parseURL } from '@/helpers/url'
  import { formatBytes, sleep } from '@/helpers/utils'
  import Vue from 'vue'
  import moment from "moment-timezone"

  export default {
    name: 'Filemanager',

    components: {
      VuePerfectScrollbar,
    },
    data: () => ({
      source: {
        id: 0,
        source: {},
        our: false,
      },
      showPassword: false,
      isOpen: false,
      isBlock: false,
      search: '',
      items: [
        { text: 'All Files', icon: 'mdi-file-multiple-outline', count: 0 },
        { text: 'New Files', icon: 'mdi-file-plus-outline', count: 0 },
        { text: 'Transcoded', icon: 'mdi-file-download-outline', count: 0 },
        { text: 'Processing', icon: 'mdi-clock-outline', count: 0 },
        { text: 'Failed', icon: 'mdi-file-alert-outline', count: 0 },
        { text: 'Deleted Files', icon: 'mdi-trash-can', count: 0 },
      ],
      fileTypes: [
        { text: 'Video', color: 'primary', count: 0 },
        { text: 'Images', color: 'green', count: 0 },
        { text: 'Subtitles', color: 'orange', count: 0 },
        { text: 'Other', color: '', count: 0 },
      ],
      fileTypesExt: {
        Video: { mp4: true, mov: true, ts: true, mpg: true, mpeg: true, m4v: true, mkv: true },
        Images: { png: true, jpeg: true, jpg: true },
        Subtitles: { vtt: true, scc: true, srt: true },
        Other: {},
      },
      folderResp: [],
      folders: [],
      selectedItem: 0,
      selectedStatus: 0,
      selectedTypes: ['Video'],
      totalSize: 0,
      totalSizeFormatted: '',
      limit: 200 * 1024 * 1024 * 1024,
      polling: null,
    }),
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      hiddenPassword () {
        if (!this.source.source.password) return ''
        return '•'.repeat(this.source.source.password.length)
      },
    },
    mounted () {
      this.updateSource()
    },
    created () {
      this.source.id = this.$route.params.source_id
      this.loadData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      updateSource () {
        this.polling = setInterval(() => {
          this.getSource()
        }, 10 * 1000)
      },
      getSource () {
        const args = {
          $expand: 'tags',
          'id[eq]': this.source.id,
        }
        const mediaSourcesReq = this.$store.dispatch('mediaSources', args)
        return Promise.all([mediaSourcesReq])
          .then((res) => {
            const mediaSources = res[0]
            if (mediaSources.length === 0) {
              return
            }

            const source = processMediaSource(mediaSources[0])
            if (this.source.state2 !== source.state2) {
              this.loadData()
            }
          })
          .catch((errorMsg) => {
            console.log('error getting source', errorMsg)
          })
      },
      loadData () {
        this.$store.commit('setPageLoader')

        const args = {
          $expand: 'tags',
          'id[eq]': this.source.id,
        }
        const mediaSourcesReq = this.$store.dispatch('mediaSources', args)

        const filesArgs = {
          sourceId: this.source.id,
        }
        const filesReq = this.$store.dispatch('mediaSourceFiles', filesArgs)
        return Promise.all([mediaSourcesReq, filesReq])
          .then((res) => {
            const mediaSources = res[0]
            if (mediaSources.length === 0) {
              this.$router.push({
                name: 'MediaSourcesPage',
              })
              return
            }

            this.source = processMediaSource(mediaSources[0])
            this.source.source = parseURL(this.source.url)
            if (this.source.source.host === 'storage005.noisypeak.com') {
              this.source.our = true
            }

            this.folderResp = res[1] || []
            this.filterFiles()
            this.countTypes()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({
              name: 'MediaSourcesPage',
            })
          })
          .finally(() => {
            sleep(500).then(() => {
              this.$store.commit('resolvePageLoader')
            })
          })
      },
      filterFiles () {
        this.folders = []
        for (let i = 0; i < this.folderResp.length; i += 1) {
          const folder = this.folderResp[i]
          const newFolder = {}
          const folderItems = []
          let folderSize = 0
          for (let j = 0; j < folder.items.length; j += 1) {
            const item = folder.items[j]
            if (this.search && !item.filepath.toLowerCase().includes(this.search.toLowerCase())) {
              continue
            }
            if (!this.isItemMatchesFileTypes(item)) {
              continue
            }
            if (!this.isItemMatchesStatus(item)) {
              continue
            }
            item.formattedSize = formatBytes(item.size)
            folderSize += item.size
            folderItems.push(item)
          }
          newFolder.name = folder.name
          newFolder.size = formatBytes(folderSize)
          newFolder.items = folderItems
          this.folders.push(newFolder)
        }
      },
      countTypes () {
        let totalSize = 0
        let videoCount = 0
        let imageCount = 0
        let subCount = 0
        let otherCount = 0

        let allFiles = 0
        let newFiles = 0
        let transcodingFiles = 0
        let transcodedFiles = 0
        let failedFiles = 0
        let deletedFiles = 0

        for (let i = 0; i < this.folderResp.length; i += 1) {
          const folder = this.folderResp[i]
          for (let j = 0; j < folder.items.length; j += 1) {
            const item = folder.items[j]
            totalSize += item.size

            let isVideo = false
            let isImg = false
            let isSub = false
            const ext = item.filepath.split('.').pop()

            for (const t in this.fileTypesExt) {
              const exts = this.fileTypesExt[t]
              // eslint-disable-next-line no-prototype-builtins
              if (t === 'Video' && exts.hasOwnProperty(ext)) {
                isVideo = true
                videoCount += 1
                // eslint-disable-next-line no-prototype-builtins
              } else if (t === 'Images' && exts.hasOwnProperty(ext)) {
                isImg = true
                imageCount += 1
                // eslint-disable-next-line no-prototype-builtins
              } else if (t === 'Subtitles' && exts.hasOwnProperty(ext)) {
                isSub = true
                subCount += 1
              }
            }
            if (!(isVideo || isImg || isSub)) {
              otherCount += 1
            }

            if (item.deleted) {
              deletedFiles += 1
            } else {
              allFiles += 1
              if (!this.isItemMatchesFileTypes(item)) {
                continue
              }
              if (item.status === 'new') {
                newFiles += 1
              }
              if (item.status === 'pending' || item.status === 'transcoding') {
                transcodingFiles += 1
              }
              if (item.status === 'transcoded') {
                transcodedFiles += 1
              }
              if (item.status === 'error') {
                failedFiles += 1
              }
            }
          }
        }
        for (let i = 0; i < this.fileTypes.length; i += 1) {
          const t = this.fileTypes[i]
          if (t.text === 'Video') {
            t.count = videoCount
          } else if (t.text === 'Images') {
            t.count = imageCount
          } else if (t.text === 'Subtitles') {
            t.count = subCount
          } else if (t.text === 'Other') {
            t.count = otherCount
          }
        }
        this.totalSize = totalSize
        this.totalSizeFormatted = formatBytes(totalSize)

        this.items[0].count = allFiles
        this.items[1].count = newFiles
        this.items[2].count = transcodedFiles
        this.items[3].count = transcodingFiles
        this.items[4].count = failedFiles
        this.items[5].count = deletedFiles
      },
      isItemMatchesFileTypes (item) {
        const ext = item.filepath.split('.').pop()
        let isVideo = false
        let isImg = false
        let isSub = false
        let isOther = false

        for (const t in this.fileTypesExt) {
          const exts = this.fileTypesExt[t]
          // eslint-disable-next-line no-prototype-builtins
          if (t === 'Video' && exts.hasOwnProperty(ext)) {
            isVideo = true
            // eslint-disable-next-line no-prototype-builtins
          } else if (t === 'Images' && exts.hasOwnProperty(ext)) {
            isImg = true
            // eslint-disable-next-line no-prototype-builtins
          } else if (t === 'Subtitles' && exts.hasOwnProperty(ext)) {
            isSub = true
          }
        }
        if (!(isVideo || isImg || isSub)) {
          isOther = true
        }
        for (let i = 0; i < this.selectedTypes.length; i += 1) {
          const t = this.selectedTypes[i]
          if (t === 'Video' && isVideo) {
            return true
          } else if (t === 'Images' && isImg) {
            return true
          } else if (t === 'Subtitles' && isSub) {
            return true
          } else if (t === 'Other' && isOther) {
            return true
          }
        }
        return false
      },
      isItemMatchesStatus (item) {
        if (this.selectedStatus === 5 && item.deleted) {
          return true
        }
        if (this.selectedStatus === 0 && !item.deleted) {
          return true
        }
        if (this.selectedStatus === 1 && !item.deleted && item.status === 'new') {
          return true
        }
        if (this.selectedStatus === 2 && !item.deleted && item.status === 'transcoded') {
          return true
        }
        if (this.selectedStatus === 3 && !item.deleted && (item.status === 'pending' || item.status === 'transcoding')) {
          return true
        }
        if (this.selectedStatus === 4 && !item.deleted && item.status === 'error') {
          return true
        }
        return false
      },
      searchItems () {
        this.filterFiles()
      },
      filterByFileTypes () {
        this.countTypes()
        this.filterFiles()
      },
      filterByStatus (item) {
        if (item.text === 'All Files') {
          this.selectedStatus = 0
        }
        if (item.text === 'New Files') {
          this.selectedStatus = 1
        }
        if (item.text === 'Transcoded') {
          this.selectedStatus = 2
        }
        if (item.text === 'Processing') {
          this.selectedStatus = 3
        }
        if (item.text === 'Failed') {
          this.selectedStatus = 4
        }
        if (item.text === 'Deleted Files') {
          this.selectedStatus = 5
        }
        this.filterFiles()
      },
      appToggle: function () {
        this.isOpen = !this.isOpen
        this.isBlock = !this.isBlock
      },
      overlayApp: function () {
        this.isOpen = !this.isOpen
        this.isBlock = !this.isBlock
      },
      highlightMatches (text) {
        if (!this.search) return text
        const matchExists = text.toLowerCase().includes(this.search.toLowerCase())
        if (!matchExists) return text
        const re = new RegExp(this.search, 'ig')
        return text.replace(re, (matchedText) => `<span class="orange--text">${matchedText}</span>`)
      },
      jumpToFolder (folder) {
        const ref = `folder${folder.name}`
        const elem = document.getElementById(ref)
        this.$nextTick(() => {
          if (elem) {
            this.$refs.scroll.$el.scrollTop = elem.offsetTop
          }
        })
      },
      syncNow () {
        const args = {
          id: this.source.id,
        }
        const syncReq = this.$store.dispatch('syncMediaSource', args)
        return Promise.all([syncReq])
          .then(() => {
            this.getSource()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
    },
  }
</script>
<style lang="scss">
.app-content-wrapper {
  position: relative;
  display: flex;
  overflow: hidden;
  height: calc(100vh - 200px);

  .app-overlay {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    display: none;
    z-index: 2;
    transition: all 0.3s ease-in;
    @media only screen and (max-width: 959px) {
      &.open {
        display: block;
        transition: all 0.3s ease-in;
      }
    }
  }
  .app-sidebar {
    width: 280px;
    position: relative;
    transition: all 0.3s ease-in;
    @media only screen and (max-width: 959px) {
      position: absolute;
      left: -340px;
      z-index: 5;
      height: calc(100vh - 120px);
      transition: all 0.3s ease-in;
      &.open {
        left: 0;
      }
    }
    .app-sidebar-header {
      padding: 0.75rem 1.25rem;
      margin-bottom: 0;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .app-sidebar-body {
      // overflow-y: scroll;
      // height: 100%;
      padding-top: 3.375rem;
      width: 280px;
    }
  }

  .app-content {
    width: calc(100% - 280px);
    @media only screen and (max-width: 959px) {
      width: 100%;
    }
    // margin-left: 30px;
    .app-header {
      padding: 0.75rem 1.25rem;
      margin-bottom: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .app-body {
      flex: 1 1 auto;
      padding-top: 3.375rem;
      // overflow-y: scroll;
      height: calc(100% - 130px);
    }
    .app-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 130px;
    }
  }
}
.app-icon {
  display: none;
  @media only screen and (max-width: 959px) {
    display: block;
  }
}
.filemanager-content {
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
}

.apps-wrapper {
  &.--filemanager {
    .nested-sidebar-toggle {
      @media (min-width: 959px) {
        display: none;
      }
    }
  }
}

#scroll .ps__rail-y {
  z-index: 999 !important;
}
</style>
